import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";

export const $AddressModuleName = "address";

export type CreateAddress = {
    firstName: string;
    lastName: string;
    street: string;
    number: string;
    box?: string;
    zipCode: string;
    city: string;
    country: string;
    addressing?: string | null;
    defaultDeliveryAddress?: boolean;
    defaultPaymentAddress?: boolean;
    validationStatus: AddressValidationStatus;
    onlyApplicableAsDeliveryAddress: boolean;
    onlyApplicableAsPaymentAddress: boolean;
};

export type CreateAddressRequest = Array<CreateAddress>;
